module.exports = __webpack_public_path__ + "static/media/ItalianatetownhouseCovingtonKY2005PencilandCoffeeonvintagepaper.8fb7a0de.webp";